import { FetchResult } from 'src/types/TApiQueries';
import { config } from 'src/utils/config';
import { getStandardHeaders, performFetchWithLogging } from '../utils/helpers';

export type ReissueCallbacksData = {
  start_date: string;
  end_date: string;
};

export async function reissueCallbacks(
  accessToken: string,
  data: ReissueCallbacksData,
): Promise<FetchResult<any>> {
  const url = `${config.hostUrl}/api/v1/callbacks/reissue`;
  const payload = JSON.stringify(data);

  return performFetchWithLogging(url, {
    method: 'POST',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
    body: payload,
  });
}

